import { ApiError } from '@spa/api';

import { environment } from '../../../environments/environment';

export class BaseException {
    public messages: string[];
    public statuses: number[];

    constructor(messages: string[], statuses: number[] = [], errors: ApiError[] = []) {
        if (!environment.production) {
            const traceIds = errors && Array.isArray(errors)
                ? errors.map(error => error.traceId?.replace(/\||\./g, ''))
                : [];

            console.error('*******Exception*********');
            console.error('status: ', ...statuses);
            console.error('traceIds: ', ...traceIds);
            console.error('messages: ', ...messages);
            console.error('*************************');
        }

        this.messages = messages;
        this.statuses = statuses;
    }
}
